<template>
  <div id="form_login_box">
    <img src="@/assets/logo.png" />
    <h1>{{ msg }}</h1>
    <form id="form_login" @submit.prevent="submit">
      <div id="input_block">
        <div>
          <input
            type="text"
            id="username"
            placeholder="Логин"
            class="form_control"
            v-model="username"
          />
        </div>
        <div>
          <input
            type="password"
            id="password"
            placeholder="Пароль"
            class="form_control"
            v-model="password"
          />
        </div>
      </div>
      <div v-if="error_message" id="error_message">{{ error_message }}</div>
      <div>
        <button id="submitbutton" class="form_control" type="submit">Войти</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

const AuthAPI = process.env.AuthAPI;
const EssRedirect = process.env.EssRedirect;

const ERROR_MESSAGE = {
  bad_ip: "Доступ с данного IP-адреса запрещен"
};

export default {
  name: "Login",
  data() {
    return {
      msg: "Вход в ЕСС",
      error_message: null,
      username: null,
      password: null
    };
  },
  mounted() {
    console.log("query", this.$route.query);
    let redirect_reason =
      this.$route.query &&
      typeof this.$route.query == "object" &&
      this.$route.query.redirect_reason
        ? this.$route.query.redirect_reason
        : null;
    if (redirect_reason && redirect_reason in ERROR_MESSAGE) {
      this.error_message = ERROR_MESSAGE[redirect_reason];
    }
  },
  methods: {
    async submit() {
      this.error_message = null;
      let redirectUri = this.$route.query.redirect_uri || null;
      if (redirectUri) {
        await this.getCode(redirectUri);
      } else {
        await this.authPost();
      }
    },
    async authPost() {
      try {
        let response = await axios.post(
          `${AuthAPI}/oauth/token`,
          qs.stringify({
            username: this.username,
            password: this.password,
            grant_type: "password",
            client_id: "ess",
            client_secret: "fwefewf4f4234f"
          }),
          {
            headers: {
              "Content-type": "application/x-www-form-urlencoded"
            }
          }
        );
        console.log("response", response);
        const redirectUrl = this.$route.query.redirect_url
          ? `&redirect_url=${this.$route.query.redirect_url}`
          : "";
        let url = `${EssRedirect}v5/app/api/oauth?access_token=${response.data.access_token}&refresh_token=${response.data.refresh_token}${redirectUrl}`;
        window.location.href = url;
      } catch (err) {
        console.log(err);
        if (
          err &&
          typeof err == "object" &&
          err.response &&
          typeof err.response == "object" &&
          err.response.status === 400 &&
          err.response.data.error === "invalid_grant"
        ) {
          this.error_message = "Вы ввели неправильно логин или пароль!";
        } else {
          this.error_message = "Произошла не предвиденная ошибка!";
        }
      }
    },
    async getCode(redirectUri) {
      let tokenResponse = await axios.post(
        `${AuthAPI}/oauth/token`,
        qs.stringify({
          username: this.username,
          password: this.password,
          grant_type: "password",
          client_id: "ess",
          client_secret: "fwefewf4f4234f"
        }),
        {
          headers: {
            "Content-type": "application/x-www-form-urlencoded"
          }
        }
      );
      console.log("tokenResponse", tokenResponse);
      let codeResponse = await axios.post(
        `${AuthAPI}/oauth/gettokencode`,
        qs.stringify({
          access_token: tokenResponse.data.access_token,
          refresh_token: tokenResponse.data.refresh_token,
          token_type: tokenResponse.data.token_type,
        }),
        {
          headers: {
            "Content-type": "application/x-www-form-urlencoded"
          }
        }
      );
      console.log("codeResponse", codeResponse);
      let delimiter = redirectUri.match(/\?/) ? '&' : '?';
      window.location.href = `${redirectUri}${delimiter}code=${codeResponse.data.code}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
  color: #fff;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#form_login_box {
  text-align: center;
  background-color: rgb(121, 191, 234);
  border-radius: 5px;
  padding: 20px 30px 20px 30px;
  border: 1px solid #fff;
  width: 330px;
}
input.form_control {
  position: relative;
  height: 44px;
  border-width: 2px;
  border-style: solid;
  border-radius: 5px;
  margin: 0 0 15px 0;
  padding: 4px 10px;
  font-size: 16px;
  font-weight: normal;
  border-color: transparent !important;
  width: 306px;
}
button.form_control {
  position: relative;
  height: 44px;
  border: 2px solid #fff;
  border-radius: 5px;
  margin: 0 0 15px 0;
  padding: 4px 10px;
  text-transform: uppercase;
  font: 300 15px/17px ProximaNova, Helvetica, Arial, sans-serif;
  background-color: rgb(99, 177, 227);
  color: #ffffff;
  width: 135px;
  text-align: center;
  cursor: pointer;
}
button.form_control:hover {
  background-color: rgb(89, 159, 204) !important;
}
#error_message {
  margin-bottom: 10px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue